import { Routes } from '@angular/router';
import { RootRedirectComponent } from './root-redirect/root-redirect.component';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';
import { azureAdAuthGuard } from './shared/guards/azure-ad-auth.guard';
import { investigationsFeatureGuard } from './shared/guards/investigations-feature.guard';

export const routes: Routes = [
  { path: '', component: RootRedirectComponent },
  { path: 'request-access', component: UnauthorizedComponent },
  {
    path: 'sdd',
    canActivate: [azureAdAuthGuard],
    loadChildren: () => import('./modules/sdd/sdd.module').then(m => m.SddModule)
  },
  {
    path: 'cdd',
    canActivate: [azureAdAuthGuard],
    loadChildren: () => import('./modules/cdd/cdd.module').then(m => m.CddModule)
  },
  {
    path: 'bq',
    loadChildren: () => import('./modules/bq/bq.module').then(m => m.BqModule)
  },
  {
    path: 'sp',
    canActivate: [azureAdAuthGuard],
    loadChildren: () => import('./modules/sp/sp.module').then(m => m.SpModule)
  },
  {
    path: 'investigations',
    canActivate: [investigationsFeatureGuard],
    loadChildren: () => import('./modules/investigations/investigations.routes').then(m => m.INVESTIGATIONS_ROUTES)
  }
];
